import { useCallback } from 'react'
import { AnalyticsEventType } from '../analytics/eventTypes'
import { AnalyticsData, trackAnalytics } from '../utils/analytics'

interface UseAnalyticsOptions {
  userId?: number
  username?: string
  enabled?: boolean
}

interface EventViewData {
  duration_ms: number
  scroll_depth_percent: number
  reached_bottom: boolean
  clicked_interpret?: boolean
  clicked_polymarket?: boolean
}

interface TrackInput {
  event_type: AnalyticsEventType
  event_id?: string
  date?: string
  data?: AnalyticsData
}

export function useAnalytics(options: UseAnalyticsOptions = {}) {
  const { enabled = true } = options

  const track = useCallback(async (event: TrackInput) => {
    if (!enabled) return
    await trackAnalytics(event)
  }, [enabled])

  const trackEventView = useCallback((eventId: string, date: string, data: EventViewData) => {
    return track({ event_type: 'event_view', event_id: eventId, date, data: { ...data } })
  }, [track])

  const trackInterpretClick = useCallback((eventId: string, date: string) => {
    return track({ event_type: 'interpret_click', event_id: eventId, date })
  }, [track])

  const trackPolymarketClick = useCallback((eventId: string, date: string, marketId?: string) => {
    return track({
      event_type: 'polymarket_click',
      event_id: eventId,
      date,
      data: marketId ? { market_id: marketId } : undefined,
    })
  }, [track])

  return {
    track,
    trackEventView,
    trackInterpretClick,
    trackPolymarketClick,
    flush: async () => undefined,
    setUser: () => undefined,
  }
}

export default useAnalytics
